// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-loading-wrapper{height:90px}.demo-loading{position:relative;top:40px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.logo-preview{height:45px}", ""]);
// Exports
module.exports = exports;
